import React from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './PageHeader.module.css';

const PageHeader = ({ title, subtitle, backUrl = null, lastPage = false, onBack, titleTag = 'h2' }) => {
  const navigate = useNavigate();
  
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backUrl) {
      navigate(backUrl);
    } else if (lastPage) {
      navigate(-1);
    }
  };

  const TitleTag = titleTag;

  return (
    <div className={classes.header}>
      {backUrl || onBack || lastPage ? (
        <button onClick={handleBack} className={classes.backButton}>
          ←
        </button>
      ) : null}
      <div>
        {title && <TitleTag className={classes.title}>{title}</TitleTag>}
        {subtitle && <h2 className={classes.subtitle}>{subtitle}</h2>}
      </div>
    </div>
  );
};

export default PageHeader;
